<template>
    <v-dialog v-model="showModal" width="500">
        <v-card>
            <v-card-title primary-title class="headline">
                {{'Bitte wählen Sie' | translation}}
            </v-card-title>

            <v-card-text>
                <v-layout>
                    <v-flex xs3>
                        <v-img
                            v-if="product"
                            :src="product.images.default.small"
                            :lazy-src="product.images.default.placeholder"
                            :alt="product.images.default.image_description"
                            :aspect-ratio="1/1"
                        />
                    </v-flex>
                    <v-flex xs9>
                        <router-link
                            :to="$product.getProductRouteConfig(product)"
                            class="subheading"
                        >
                            {{$basket.getItemTitle(product)}}
                        </router-link>

                        <product-variants
                            :variants="product && product.variants ? product.variants : []"
                            :variants-ids="product && product.variantsIds ? product.variantsIds : []"
                            v-model="variantId"
                        />

                        <div class="text-xs-right">
                            <p class="subheading">{{ 'from' | translation }} {{getProductPrice(product) | currency}}</p>
                            <div v-if="!hideAmountInput">
                                <amount-input
                                    class="amount-input d-inline-block"
                                    :value.sync="amountValue"
                                    :product="product"
                                    :current-merchant-id="Object.keys(this.product.merchant)[0]"
                                    :current-product-id="variantId"
                                    hide-tier-price-info
                                />
                            </div>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>

            <v-card-actions>
                <v-btn @click="$emit('input', false)">{{'Close' | translation}}</v-btn>
                <v-spacer></v-spacer>
                <basket-button
                    :product="product"
                    :current-merchant-id="Object.keys(product.merchant)[0]"
                    :amount-value="amountValue"
                    :current-product-id="variantId"
                    @beforeAddToBasket="$emit('beforeAddToBasket', $event)"
                    @afterAddToBasket="afterAddToBasket"
                ></basket-button>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import ProductVariants from './product-page/ProductVariants';
    import AmountInput from './product-page/AmountInput';
    import BasketButton from './product-page/BasketButton';
    import {mapGetters, mapMutations} from 'vuex';

    export default {
        props: {
            value: Boolean,
            product: {},
            quantity: Number,
            hideAmountInput: Boolean,
        },
        components: {
            ProductVariants,
            AmountInput,
            BasketButton,
        },
        data() {
            return {
                variantId: this.product.id,
            };
        },
        computed: {
            ...mapGetters([
                'getAmountValue',
            ]),
            showModal: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
            amountValue: {
                get() {
                    return this.quantity || this.getAmountValue;
                },
                set(value) {
                    this.setAmountValue(value);
                },
            },
        },
        methods: {
            ...mapMutations('Product', [
                'setProduct',
                'setCurrentMerchantId',
                'setAmountValue',
                'resetAmountValue',
                'setCurrentProductId',
            ]),
            getProductPrice(product) {
                if (product.prices.default && product.prices.default.original_price_inkl_vat) {
                    return product.prices.default.original_price_inkl_vat;
                }
            },
            afterAddToBasket(event) {
                this.$emit('input', false);
                this.$emit('afterAddToBasket', event);
            },
        },
    };
</script>